// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3Q_Ct","gradiantBG":"styles_gradiantBG__4j35Y"};